<div class="hd_2_1">
  <h2>{{ 'UploadDocuments' | translate }}</h2>
  <p>To become a Seller you need to Upload your Documents and get Verified by OWNRSCLB</p>
</div>
<div  class="btn_group">
  <button (click)="onDialogAction()" class="btnn btn_primary">{{ 'Upload' | translate }}</button>
</div>
